import React from 'react';

export const ContentCollectionListLazy = React.lazy(
  () => import('./ContentCollectionList')
);
